import React, { useEffect, useRef } from 'react';
import anime from 'animejs'
import * as THREE from 'three';

import Nav from './components/nav';
import Home from './pages/home';
import Intro from './pages/intro';
import doggy from './static/doggy.png'

import './common.css';

const App = () => {
  const background = useRef(null);

  const scene = new THREE.Scene();

  const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);

  useEffect(() => {
    const renderer = new THREE.WebGLRenderer();
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight);
    document.body.appendChild(renderer.domElement);
    var geometry = new THREE.TorusGeometry(2, 1, 36, 100);
    var material = new THREE.MeshStandardMaterial({ color: 0xffc0cb });
    var sphere = new THREE.Mesh(geometry, material);
    scene.add(sphere);

    const pointLight = new THREE.PointLight(0xffffff)
    const pointLight2 = new THREE.PointLight(0xffffff)

    pointLight.position.set(10, 10, 10)
    pointLight2.position.set(-1, -1, -1)
    scene.add(pointLight);
    scene.add(pointLight2);
    camera.position.z = 15;
    sphere.position.x = 5;
    sphere.position.y = 6;

    const marvinLoader = new THREE.TextureLoader().load('./static/doggy.png')

    scene.background = marvinLoader
    var animate = function () {
      requestAnimationFrame(animate);
      sphere.rotation.x += 0.009;
      sphere.rotation.y += 0.003;
      sphere.rotation.z += 0.01;

      renderer.render(scene, camera);
    };
    animate();

  }, [])

  return (
    <div className="App">
      <div className="App-header" ref={background}>
        <div className="layout">
          <Intro />
          <Home />
          <Nav />
          <img
            className='doggy'
            src={doggy}
            alt='marvin'
          />
        </div>
      </div>
    </div>
  )
};

export default App;
